module.exports = __webpack_public_path__ + "media/images/emblems/Chexbres-coat_of_arms-cf326d20145cc8d2c0cb7161d8e10101.svg";